import { actionTypes } from '../actions/constants';
const defaultState = {
    items: []
};

export default (state = defaultState, action) => {

    switch (action.type) {
        case actionTypes.SET_CART_ITEMS:
            return Object.assign({}, state, {
                items: action.payload.items
            });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/cartReducer.js